import styled from '@emotion/styled';

import { ButtonBase } from 'components/buttons/ButtonBase';

export const ButtonSlim = styled(ButtonBase)`
  background: ${({ theme }) => theme.colors.action};

  &:hover {
    background: ${({ theme }) => theme.colors.action};
    opacity: 0.8;
  }
`;
